export const playParentEntityToIdKey: Record<'demo' | 'playbook', string> = {
  demo: 'demoId',
  playbook: 'playbookId',
};
